import { render, staticRenderFns } from "./MalikiBilgisiForm.vue?vue&type=template&id=7879b4bb"
import script from "./MalikiBilgisiForm.vue?vue&type=script&lang=ts"
export * from "./MalikiBilgisiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports